<template>
  <div class="detail-remaining-container">
    <div class="detail-remaining-content">
      <div class="detail-header">
        <div class="detail-tree">
          <!-- YEAR LOOP -->
          <div
            v-for="year in groupedLeaveHistory"
            :key="year"
            class="detail-tree-period"
          >
            <div class="period-header">
              {{ year.year }}
            </div>

            <div class="detail-tree-inherit">
              <!-- LEAVE LOOP -->
              <div
                v-for="leave in year.leaves"
                :key="leave"
                class="parent-tree-container"
              >
                <!-- <div
                  v-for="value in leave.history"
                  :key="value"
                  class="parent-tree-content"
                > -->
                <div class="parent-tree-content">
                  <div class="leave-name" style="margin-bottom: 4px;">
                    {{ leave.leave_name }}
                  </div>

                  <div class="leave-info" style="margin-bottom: 12px;">
                    Max: {{ dataParent.max_qty }} | Used: {{ dataParent.used }} | Sisa: {{ dataParent.sisa_cuti }}
                  </div>

                  <!-- <div
                    v-for="child in leave.history"
                    :key="child"
                    class="child-tree-container"
                    :class="{
                      'child-tree-yellow':
                        child.state == 'Waiting for Approval',
                      'child-tree-green': child.state == 'Approved',
                      'child-tree-red': child.state == 'Rejected',
                    }"
                  > -->
                  <div
                    v-for="child in leave.history"
                    :key="child"
                    class="child-tree-container"
                  >
                    <p>
                      <b>{{ formatDate("datetime", child.leave_date) }}</b>
                    </p>
                    <p>{{ child.transaction_no ? child.transaction_no + " | " + child.transaction : child.transaction }}  <b>( {{ child.day_leave_amount }} days ) </b></p>
                    <p>{{ child.remarks }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END YEAR LOOP -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { computed, watchEffect } from "vue"

  export default {
    props: {
      dataParent: { type: Array, default: () => [] },
      detailData: { type: Array, default: () => [] },
    },

    setup(props, { emit }) {
      const monthsEn = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      function formatDate(type, date) {
        const day = new Date(date).getDate();
        const month = new Date(date).getMonth();
        const year = new Date(date).getFullYear();
        const dayOfWeek = new Date(date).getDay();
        var time =
          ("0" + new Date(date).getHours()).slice(-2) +
          "." +
          ("0" + new Date(date).getMinutes()).slice(-2);

        if (type == "date") {
          const formattedDate = `${day} ${monthsEn[month]} ${year}`;
          return formattedDate;
        } else if (type == "datetime") {
          const formattedDate = `${day} ${monthsEn[month]} ${year}, ${time}`;
          return formattedDate;
        }
      }

      const groupedLeaveHistory = computed(() => {
        const yearMap = {}

        props.detailData.forEach(item => {
          const year = item.year
          const leaveId = item.leave_id

          if (!yearMap[year]) {
            yearMap[year] = {}
          }

          if (!yearMap[year][leaveId]) {
            yearMap[year][leaveId] = {
              leave_id: leaveId,
              leave_name: item.leave_name,
              history: []
            }
          }

          yearMap[year][leaveId].history.push(item)
        })

        return Object.keys(yearMap)
          .sort((a, b) => b - a)
          .map(year => ({
            year,
            leaves: Object.values(yearMap[year])
          }))
      })

      return {
        formatDate,
        groupedLeaveHistory
      }
    }
  }
</script>

<style lang="scss" scoped>
  .detail-remaining-container {
    width: 100%;
    height: 100%;
    padding: 8px 20px 20px 20px;
    background-color: white;
    overflow-y: auto;

    .detail-remaining-content {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .detail-header {
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid lightgray;

        p {
          width: 100%;

          &:nth-child(1) {
            font-size: 20px;
            line-height: 32px;
            font-weight: 500;
          }

          &:nth-child(2) {
            font-size: 14px;
            line-height: 24px;
            font-weight: 500;
            margin-bottom: 12px;
          }
        }

        table {
          width: 100%;

          tr {
            td {
              padding: 0;
              font-size: 14px;
              line-height: 24px;
              color: gray;

              &:nth-child(1) {
                width: 120px;
              }

              &:nth-child(2) {
                width: 10px;
              }

              &:nth-child(3) {
                color: black;
                font-weight: 500;
              }
            }
          }
        }
      }

      .detail-tree {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;
        // background-color: red;

        .parent-tree-container {
          width: 100%;
          background-color: rgb(236, 250, 255);
          border-radius: 16px;
          padding: 0 12px;

          .parent-tree-content {
            width: 100%;
            padding: 8px 0;

            p {
              width: 100%;
              font-size: 14px;
              line-height: 24px;
            }
          }

          .child-tree-container {
            width: calc(100% - 32px);
            margin-left: 32px;
            position: relative;
            background-color: white;
            border: 2px solid white;
            border-radius: 12px;
            padding: 8px 12px;
            margin-bottom: 16px;

            &::before {
              content: "";
              width: 1px;
              height: calc(100% + 20px);
              position: absolute;
              top: 0;
              left: -16px;
              background-color: gray;
            }

            &::after {
              content: "";
              width: 12px;
              height: 12px;
              border-radius: 50%;
              position: absolute;
              top: 12px;
              left: -21.6px;
              background-color: gray;
            }

            &:nth-last-child(1) {
              margin-bottom: 12px;

              &::before {
                height: 24px;
              }
            }

            p {
              font-size: 14px;
              line-height: 24px;
            }
          }

          .child-tree-yellow {
            background-color: rgb(255, 250, 237);
            border: 2px solid rgb(255, 235, 184);
          }
          .child-tree-green {
            background-color: rgb(237, 255, 237);
            border: 2px solid rgb(195, 255, 195);
          }
          .child-tree-red {
            background-color: rgb(255, 237, 237);
            border: 2px solid rgb(255, 192, 185);
          }
        }

        .detail-tree-period {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 20px;

          .period-header {
            width: 100%;
            height: auto;
            text-align: left;
            font-weight: 700;
            font-size: 20px;
            line-height: 32px;
            // padding: 0 0 0 20px;
          }

          .detail-tree-inherit {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 0 0 0 40px;
            position: relative;

            .parent-tree-container {
              position: relative;

              &::before {
                content: "";
                width: 1px;
                height: calc(100% + 20px);
                position: absolute;
                top: 0;
                left: -20px;
                background-color: lightgray;
              }

              &::after {
                content: "";
                width: 16px;
                height: 16px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: -27px;
                background-color: lightgray;
              }

              &:nth-child(1) {
                &::before {
                  height: calc(100% + 20px + 20px);
                  top: -20px;
                }
              }

              &:nth-last-child(1) {
                &::before {
                  height: 50%;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
